
  import ipxStaticRuntime$kQxv_45R_45d6UetjgEQAvlNFm_45PZZVJn9fukx_45sNZT6nDU from '/home/runner/work/psj-nuxt/psj-nuxt/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    /** @type {"ipxStatic"} */
    provider: "ipxStatic",
    providers: {
        ['ipxStatic']: { setup: ipxStaticRuntime$kQxv_45R_45d6UetjgEQAvlNFm_45PZZVJn9fukx_45sNZT6nDU, defaults: {} }
    }
  }
